import { defaultListener } from '../helper'

export default {
  state: {
    productVariants: {}
  },
  getters: {
    allProductVariants(state) {
      return Object.values(state.productVariants)
        .sort((a, b) => {
          return !!a.isArchived - !!b.isArchived
        })
    },
    getProductVariant: (state) => (id) => state.productVariants[ id ] || {},
    getVariantsByProduct: (state) => (productId) => {
      return Object.values(state.productVariants)
        .filter(p => p.productId === productId)
    }
  },
  actions: {
    async initVariantsForProduct({ getters, commit }, data) {
      const { productId } = data || {}

      const sessionTenant = getters.getSessionTenant

      this.$db.collection('tenants')
        .doc(sessionTenant)
        .collection('productVariants')
        .where('productId', '==', productId)
        .onSnapshot(defaultListener.bind(this, commit, 'ADD_PRODUCT_VARIANT', 'REMOVE_PRODUCT_VARIANT'))
    },
  },
  mutations: {
    ADD_PRODUCT_VARIANT(state, variant) {
      const { id } = variant

      if (id) {
        const newState = { ...state.productVariants }
        newState[ id ] = variant
        state.productVariants = newState
      }
    },
    REMOVE_PRODUCT_VARIANT(state, id) {
      if (state.productVariants[ id ]) {
        const newState = { ...state.productVariants }
        delete newState[ id ]
        state.productVariants = newState
      }
    }
  },
}
